export const STOREFRONT_API_VERSION = '2025-01';
